import { defineComponent as _defineComponent } from 'vue'
import dayjs from "dayjs";
  import { computed, ref, watch } from "vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'Calendar',
  props: {
    modelValue: String,
    min: String,
    max: String,
    withPicker: {
      type: Boolean,
      default: true,
    },
    withArrow: {
      type: Boolean,
    },
    showToday: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["update:modelValue", "updateFilter"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;
  const emit = __emit;
  const days = ref(
    [] as { day: number; date: string; hidden: boolean; disabled: boolean }[]
  );
  const minDate = props.min
    ? new Date(
        parseInt(props.min.split("-")[0]),
        parseInt(props.min.split("-")[1]) - 1,
        parseInt(props.min.split("-")[2])
      )
    : null;
  const maxDate = props.max
    ? new Date(
        parseInt(props.max.split("-")[0]),
        parseInt(props.max.split("-")[1]) - 1,
        parseInt(props.max.split("-")[2])
      )
    : null;
  const formatDate = (date: string | Date = new Date()) => {
    let value = typeof date === "string" ? new Date(date) : date;

    return `${value.getFullYear()}/${value.getMonth() + 1}/${value.getDate()}`;
  };

  const selectedDate = ref("");
  const currentMonth = new Date().getMonth() + 1;
  const selectedMonth = ref(currentMonth);

  watch(selectedMonth, () => buildDays());
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const currentYear = (maxDate ? maxDate : new Date()).getFullYear();
  const selectedYear = ref(new Date().getFullYear());

  watch(selectedYear, () => buildDays());
  const years = Array.from(
    { length: currentYear - (minDate ? minDate.getFullYear() : 1900) + 1 },
    (_, i) => (minDate ? minDate.getFullYear() : 1900) + i
  );

  const buildDays = () => {
    const daysCount = new Date(
      selectedYear.value,
      selectedMonth.value,
      0
    ).getDate();
    const firstDayCurrent = new Date(
      selectedYear.value,
      selectedMonth.value - 1,
      1
    ).getDay();
    const lastDayPrev = new Date(
      selectedYear.value,
      selectedMonth.value - 1,
      0
    ).getDate();
    const daysArray = [
      ...Array.from(
        { length: firstDayCurrent > 0 ? firstDayCurrent - 1 : 6 },
        (_, i) => {
          const dayNum =
            lastDayPrev -
            (firstDayCurrent > 0 ? firstDayCurrent - 1 : 6) +
            i +
            1;
          const date = new Date(
            selectedYear.value,
            selectedMonth.value - 2,
            dayNum
          );

          return {
            day: dayNum,
            date: formatDate(date),
            hidden: true,
            disabled: false,
          };
        }
      ),
      ...Array.from({ length: daysCount }, (_, i) => {
        const dayNum = i + 1;
        const date = new Date(
          selectedYear.value,
          selectedMonth.value - 1,
          dayNum
        );

        return {
          day: dayNum,
          date: formatDate(date),
          hidden: false,
          disabled: isDisabled(date),
        };
      }),
    ];

    days.value = [
      ...daysArray,
      ...Array.from({ length: 35 - daysArray.length }, (_, i) => {
        const dayNum = i + 1;
        const date = new Date(selectedYear.value, selectedMonth.value, dayNum);

        return {
          day: dayNum,
          date: formatDate(date),
          hidden: true,
          disabled: false,
        };
      }),
    ];
  };
  const isDisabled = (date: Date) => {
    return !!(
      (maxDate && date > new Date(maxDate.setHours(0, 0, 0, 0))) ||
      (minDate && date < new Date(minDate.setHours(0, 0, 0, 0)))
    );
  };
  const selectDate = (date: string) => {
    if (!props.withPicker) {
      return;
    }

    selectedDate.value = date;
    emit("update:modelValue", selectedDate.value);
  };

  watch(
    () => props.modelValue,
    () => {
      if (props.modelValue) {
        const date = new Date(props.modelValue);

        selectedYear.value = date.getFullYear();
        selectedMonth.value = date.getMonth() + 1;
        selectedDate.value = formatDate(date);
      }
    },
    { immediate: true }
  );

  const prevMonth = () => {
    if (!showPrevArrow.value) {
      return;
    }

    const newDate = dayjs({
      year: selectedYear.value,
      month: selectedMonth.value - 1,
    }).subtract(1, "month");

    selectedMonth.value = Number(newDate.format("M"));
    selectedYear.value = Number(newDate.format("YYYY"));
    emit("updateFilter", newDate);
  };
  const nextMonth = () => {
    if (!showNextArrow.value) {
      return;
    }

    const newDate = dayjs({
      year: selectedYear.value,
      month: selectedMonth.value - 1,
    }).add(1, "month");

    selectedMonth.value = Number(newDate.format("M"));
    selectedYear.value = Number(newDate.format("YYYY"));
    emit("updateFilter", newDate);
  };

  const showNextArrow = computed(() => {
    if (!props.withArrow || !props.max) {
      return false;
    }

    const nextDate = dayjs({
      year: selectedYear.value,
      month: selectedMonth.value - 1,
    }).add(1, "month");

    return nextDate.isSameOrBefore(dayjs(props.max).endOf("month"));
  });

  const showPrevArrow = computed(() => {
    if (!props.withArrow || !props.min) {
      return false;
    }

    const prevDate = dayjs({
      year: selectedYear.value,
      month: selectedMonth.value - 1,
    }).subtract(1, "month");

    return prevDate.isSameOrAfter(dayjs(props.min).startOf("month"));
  });

  buildDays();

const __returned__ = { props, emit, days, minDate, maxDate, formatDate, selectedDate, currentMonth, selectedMonth, months, currentYear, selectedYear, years, buildDays, isDisabled, selectDate, prevMonth, nextMonth, showNextArrow, showPrevArrow, get dayjs() { return dayjs }, computed, ref, watch }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})